import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import SwalServices from "../../../services/swalServices/SwalServices";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import { PaymentReceivePopUp } from "./PaymentReceiveTable";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { PartyAccountPopUp } from "../paymentVoucher/PartyAccountPopUp";
import { CommonValidationMessages } from "../../../utils/Messages";
import { isValidForm } from "../../../utils/validation/CommonValidator";
import moment from "moment";
import { decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import { permission } from "../../../utils/enums/ValidationMessage";
import DailyReportsServices from "../../../services/axiosServices/apiServices/DailyReportsServices";

class PaymentReceive extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            urlId: 0,
            prop: {},
            rowData: [],
            colDefs: [],
            table2Data: [],
            table2ColDefs: [],
            caption: "",
            colName: "",
            paginationPageSize: 50,
            rowHeight: 40,
            // Row and Columns are written in PaymentVoucherTable.js folder for all
            // Row and Columns are written in PaymentVoucherTable.js folder for all
            // Row and Columns are written in PaymentVoucherTable.js folder for all
            paymentDetails: {
                idPaymentReceive: 0,
                updateStatus: 0,
                receiptNo: "",
                selectVendor: "",
                paymentDate: "",
                refNo: "",
                paymentMode: "",
                selectBank: "",
                selectSeries: "",
                idChequeBookDetails: 0,
                chequeNo: "",
                chequeDate: "",
                openingBalance: "",
                pendingBalance: "",
                paidAmount: 0,
                remarks: "",
                selectedVendorId: 0,
                selectedVendorName: "",
                outStandingBalance: 0,
                finalCurrentBalance: 0,
                paymentModeName: "",
                paymentModeId: 0,
                idBank: 0,
                bankName: "",
                idChequeBookMaster: 0,
                chequeBookSeries: "",
                idFinancialYear: 0,
                e_Date: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                selectedVendorName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "vendor name"
                        ),
                    },
                ],
                paymentDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "payment date"
                        ),
                    },
                ],
                // refNo: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "reference no"
                //         ),
                //     },
                // ],
                paymentModeId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "payment mode"
                        ),
                    },
                ],
                idBank: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "bank"
                        ),
                    },
                ],
                // chequeNo: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "cheque no"
                //         ),
                //     },
                // ],
                // chequeDate: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "cheque date"
                //         ),
                //     },
                // ],
                paidAmount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "receive amount"
                        ),
                    },
                ],
                // pendingBalance: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "pending balance"
                //         ),
                //     },
                // ],
            },
            idCompany: 0,
            idUser: 0,
            partyAccountList: [],
            paymentModeList: [],
            mainPaymentModeList: [],
            bankList: [],
            mainBankList: [],
            chequeNoList: [],
            mainChequeNoList: [],
            isPartyAccountPopUp: false,
            paymentModeolDefsColDefs: [
                {
                    field: "type",
                    headerName: "Type",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "partyACName",
                    headerName: "Party Ac Name",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            series: [],
            isSeriesPopUp: false,
            seriesColDefs: [
                {
                    field: "chequeBookSeries",
                    headerName: "Cheque Book Series",
                    minWidth: window.innerWidth * 0.11,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "date",
                    headerName: "Date",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                }
            ],
        };
        this.gridApi = null;
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            }
            else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        //this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Payment Receive");
        //}
        let data = this.state.paymentDetails;
        data.idPaymentReceive = event.data.idPaymentReceive;
        this.setState({ paymentDetails: data });
    };

    componentDidMount = () => {

        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }


        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect()
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            this.removeDefaultBorders();
        }, 100);
        //window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        //debugger;
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let data = this.state.paymentDetails;
            let requestData = {
                idPaymentReceive: data.updateStatus === 1 ? data.idPaymentReceive : 0,
                receiptNo: data.receiptNo,
                date: (data.paymentDate && data.paymentDate !== 'Invalid date') ? data.paymentDate : '',
                idCustomer: data.selectedVendorId,
                refNo: data.refNo,
                paymentMode: data.paymentModeId,
                chequeNo: data.chequeNo,
                chequeDate: (data.chequeDate && data.chequeDate !== 'Invalid date') ? data.chequeDate : '',
                outstandingBalance: Number(data.finalCurrentBalance).toFixed(2),
                amountRec: Number(data.paidAmount).toFixed(2),
                pendingBalance: Number(data.pendingBalance).toFixed(2),
                idCompany: this.state.idCompany,
                e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                e_IdUser: this.state.idUser,
                isUpdated: data.updateStatus === 1 ? 1 : null,
                updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null,
                u_IdUser: data.updateStatus === 1 ? this.state.idUser : 0,
                isDeleted: 0,
                deletedDate: null,
                d_IdUser: null,
                remarks: data.remarks,
                idBank: data.idBank,
                idFinancialYear: data.idFinancialYear,
                updateStatus: data.updateStatus,
            };
            this.isSubmitting = true;
            this.setState({ isSaving: true });
            this.accountTransactionServices.usp_Transaction_PaymentRecvInsertUpdate(requestData).then((response) => {
                //debugger
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData !== null) {
                        if (this.state.paymentDetails.updateStatus === 1) {
                            this.SwalServices.Success("Updated sucessfully.");
                        } else {
                            this.SwalServices.Success("Save sucessfully.");
                        }
                        if (this.state.urlId) {
                            this.setState({ route: '/ledger-report' });
                        } else {
                            this.resetPaymentDetailsFields();
                            this.setState({
                                isModalOpen: false,
                            }, () => {
                                this.procSelectAllRecordsSP();
                            });
                        }
                    } else {
                        this.procSelectAllRecordsSP();
                    }
                }
            }).finally(() => {
                this.isSubmitting = false;
                this.setState({ isSaving: false });
            });
        }
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.paymentDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    this.setState({
                        partyAccountList: dynamicData,
                    }, () => {
                        this.usp_Master_PaymentModeSelect();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.usp_Master_PaymentModeSelect();
                }
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay(); // Show loading overlay initially
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };

    usp_Master_PaymentModeSelect = () => {
        this.accountTransactionServices.usp_Master_PaymentModeSelect(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        id: x.idPaymentMode,
                        name: x.paymentMode,
                    }));
                    this.setState({
                        paymentModeList: dynamicData,
                        mainPaymentModeList: dynamicData
                    }, () => {
                        this.usp_Master_BankSelect();
                    });
                } else {
                    this.usp_Master_BankSelect();
                }
            }
        });
    }
    usp_Master_BankSelect = () => {
        this.accountTransactionServices.usp_Master_BankSelect(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                dynamicData = dynamicData.map((x) => ({
                    id: x.idBank,
                    name: x.bankName,
                }));
                this.setState({
                    bankList: dynamicData,
                    mainBankList: dynamicData
                });
            }
        });
        this.usp_Transaction_PaymentRecvCount();
    }

    usp_Transaction_PaymentRecvCount = () => {
        let request = {
            idCompany: this.state.idCompany,
            idFinancialYear: 0,
        };
        //debugger;
        this.accountTransactionServices.usp_Transaction_PaymentRecvCount(request).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                // let res = toString(response.responseItem.responseContent["="]);
                //let res =  toString([=]); //cout['=']; //`${cout}`;
                let data = this.state.paymentDetails;
                // if (res[0] > 1) {
                //     //data.receiptNo
                // }
                // if (res.length === 1)
                //     data.receiptNo = "00" + res;
                // if (res.length === 2)
                //     data.receiptNo = "0" + res;
                // if (res.length > 2)
                //     data.receiptNo = res;
                // data.receiptNo = '00' + '1';
                this.setState({
                    paymentDetails: data
                });
            }
        });
    }

    usp_Master_PartyAccountSelectOutstandingAmt = () => {
        let request = {
            idPartyAccount: this.state.paymentDetails.selectedVendorId,
            idCompany: this.state.idCompany
        };
        this.accountTransactionServices.usp_Master_PartyAccountSelectOutstandingAmt(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                let data = this.state.paymentDetails;
                data.outStandingBalance = dynamicData.finalVendorCurrentBalance;
                data.finalCurrentBalance = dynamicData.finalCurrentBalance;
                this.setState({
                    paymentDetails: data
                });
            }
        });
    }

    getClosingBalance = () => {
        const requestCopy = {
            fromDate: "2024-01-01",
            toDate: moment().format('YYYY-MM-DD'),
            partyId: this.state.paymentDetails.selectedVendorId,
            exponseById: 1,
            idCompany: this.state.idCompany,
        };

        this.dailyReportsServices.getLedgerReportRecords(requestCopy).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                const { openingBalance, openingBalanceType } = this.state;

                const openingValue = Number(openingBalance) || 0;
                const openingDR = openingBalanceType === "DR" ? openingValue : 0;
                const openingCR = openingBalanceType === "CR" ? openingValue : 0;

                let totalDebit = openingDR;
                let totalCredit = openingCR;

                response.responseItem.responseContent.forEach((item) => {
                    totalDebit += Number(item.debitAmount) || 0;
                    totalCredit += Number(item.creditAmount) || 0;
                });

                let closingAmount = 0;
                let closingType = "";

                if (totalDebit > totalCredit) {
                    closingAmount = totalDebit - totalCredit;
                    closingType = "DR";
                } else if (totalCredit > totalDebit) {
                    closingAmount = totalCredit - totalDebit;
                    closingType = "CR";
                }

                const closingBalance = closingAmount;
                let data = this.state.paymentDetails;
                data.outStandingBalance = closingBalance;
                data.finalCurrentBalance = closingBalance > 0 ? closingBalance : 0;
                this.setState({ closingBalance, paymentDetails: data });
            } else {
                this.SwalServices.showError(response.message);
            }
        }).catch((error) => {
            console.error("Error fetching closing balance:", error);
        });
    };

    usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake = () => {
        let request = {
            idBank: this.state.paymentDetails.selectedVendorId,
            updateStatus: this.state.paymentDetails.updateStatus,
        };
        this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                //let data = this.state.receiptDetails;
                // data.outStandingBalance = dynamicData.finalVendorCurrentBalance;
                // data.finalCurrentBalance = dynamicData.finalCurrentBalance;
                this.setState({
                    series: data
                });
            }
        });
    }

    usp_Master_ChequeBookNoSelectbyChequeBookSeries = () => {
        let request = {
            idChequeBookMaster: this.state.paymentDetails.idChequeBookMaster,
            updateStatus: this.state.paymentDetails.updateStatus,
            idPaymentMake: this.state.paymentDetails.idPaymentMake,
        };
        this.accountTransactionServices.usp_Master_ChequeBookNoSelectbyChequeBookSeries(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                dynamicData = dynamicData.map((x) => ({
                    id: x.idChequeBookDetails,
                    name: x.chequeNo,
                }));
                this.setState({
                    chequeNoList: dynamicData,
                    mainChequeNoList: dynamicData,
                });
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Payment Receive",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key === 'account' ? 'Party Name' : key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            minWidth: this.getColumnWidth(key),
                            hide: ["idPaymentReceive", "chequeDate", "sR.No"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            pinned: key === "receiptNo" || key === "date" || key === "refNo" || key === "bankName" || key === "account" ? "left" : undefined,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Payment Receive",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Payment Receive");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.paymentDetails;
        details.idPaymentReceive = id;
        this.setState({ paymentDetails: details }, () => {
            this.openPopUpForUpdateItem();
        });
    };

    getColumnWidth = (key) => {
        const columnWidths = {
            "idPaymentReceive": window.innerWidth * 0.085,
            "sR.No": window.innerWidth * 0.05,
            "receiptNo": window.innerWidth * 0.066,
            "date": window.innerWidth * 0.08,
            "refNo": window.innerWidth * 0.07,
            "bankName": window.innerWidth * 0.2,
            "chequeNo": window.innerWidth * 0.08,
            "chequeDate": window.innerWidth * 0.08,
            "account": window.innerWidth * 0.13,
            "paymentMode": window.innerWidth * 0.06,
            "amountRec": window.innerWidth * 0.06,
            "remarks": window.innerWidth * 0.06,
            "approvalStatus": window.innerWidth * 0.1,
        };
        return columnWidths[key];
    };
    getPinnedWidth = (key) => {
        const pinnedWidths = {
            "sR.No": window.innerWidth * 0.06,
            "receiptNo": window.innerWidth * 0.07,
            "date": window.innerWidth * 0.08,
            "refNo": window.innerWidth * 0.07,
            "bankName": window.innerWidth * 0.17,
            "account": window.innerWidth * 0.12,
        }
        return pinnedWidths[key];
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        //debugger;
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        //debugger
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                //debugger
                if (response.statusCode === 200 && response.responseItem !== null) {
                    //debugger;
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            // flex: 1,
                            filter: true,
                            floatingFilter: true,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
        this.resetPaymentDetailsFields()
    };

    setOpenModel2 = () => {
        this.setState({ isPartyAccountPopUp: !this.state.isPartyAccountPopUp });
    };

    setOpenModel3 = () => {
        this.setState({ isSeriesPopUp: !this.state.isSeriesPopUp });
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        let list = this.state.rowData
        let maxIdPaymentMake = list.length > 0
            ? Math.max(...list.map(item => item.idPaymentReceive))
            : 0;

        let receiptNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        let details = this.state.paymentDetails
        details.receiptNo = receiptNo
        this.setState({ isModalOpen: true, paymentDetails: details });
        this.usp_Master_PartyAccountSelect();
    };

    resetPaymentDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        var paymentDetail = this.state.paymentDetails;
        paymentDetail.idPaymentReceive = "";
        paymentDetail.updateStatus = "";
        paymentDetail.receiptNo = "";
        paymentDetail.paymentDate = "";
        paymentDetail.refNo = "";
        paymentDetail.paymentMode = "";
        paymentDetail.selectBank = "";
        paymentDetail.selectSeries = "";
        paymentDetail.idChequeBookDetails = "";
        paymentDetail.chequeNo = "";
        paymentDetail.chequeDate = "";
        paymentDetail.openingBalance = "";
        paymentDetail.pendingBalance = "";
        paymentDetail.paidAmount = "";
        paymentDetail.remarks = "";
        paymentDetail.selectedVendorId = "";
        paymentDetail.selectedVendorName = "";
        paymentDetail.outStandingBalance = "";
        paymentDetail.finalCurrentBalance = "";
        paymentDetail.paymentModeName = "";
        paymentDetail.paymentModeId = "";
        paymentDetail.idBank = "";
        paymentDetail.bankName = "";
        paymentDetail.idChequeBookMaster = "";
        paymentDetail.chequeBookSeries = "";
        paymentDetail.idFinancialYear = "";
        paymentDetail.e_Date = "";
        this.setState({ paymentDetails: paymentDetail, validState: validState });
    }

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.openPopUpForUpdateItem(event);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };
    openPopUpForUpdateItem = () => {
        // this.setState({ isModalOpen: true });
        // this.usp_Master_PartyAccountSelect();
        this.accountTransactionServices.usp_Transaction_PaymentRecvSelectbyId(this.state.paymentDetails.idPaymentReceive).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData !== null) {
                    let paymentDetail = this.state.paymentDetails;

                    paymentDetail.idPaymentReceive = dynamicData.idPaymentReceive;
                    paymentDetail.updateStatus = 1;
                    paymentDetail.receiptNo = dynamicData.receiptNo;
                    paymentDetail.paymentDate = moment(dynamicData.date).format('YYYY-MM-DD'); // dynamicData.date;
                    paymentDetail.refNo = dynamicData.refNo;
                    paymentDetail.selectedVendorId = dynamicData.idCustomer;
                    paymentDetail.selectedVendorName = this.state.partyAccountList?.find(item => item.idPartyAccount === dynamicData.idCustomer)?.partyACName;;
                    paymentDetail.paymentModeId = dynamicData.paymentMode;
                    paymentDetail.paymentModeName = this.state.paymentModeList?.find(item => item.id === dynamicData.paymentMode)?.name;
                    paymentDetail.chequeDate = moment(dynamicData.chequeDate).format('YYYY-MM-DD'); //dynamicData.chequeDate;
                    paymentDetail.pendingBalance = dynamicData.pendingBalance;
                    paymentDetail.paidAmount = dynamicData.amountRec;
                    paymentDetail.remarks = dynamicData.remarks;
                    paymentDetail.finalCurrentBalance = dynamicData.outstandingBalance;
                    paymentDetail.idBank = dynamicData.idBank;
                    paymentDetail.bankName = this.state.bankList?.find(item => item.id === dynamicData.idBank)?.name;
                    paymentDetail.chequeNo = dynamicData.chequeNo;
                    paymentDetail.idFinancialYear = dynamicData.idFinancialYear;
                    paymentDetail.e_Date = dynamicData.e_Date;

                    this.setState({ paymentDetails: paymentDetail, isModalOpen: true })
                }
            }
        });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.paymentDetails;
        if (name === 'paidAmount') {
            details.paidAmount = value;
            details.pendingBalance = details.finalCurrentBalance - details.paidAmount;
        } else {
            details[name] = value;
        }
        this.setState({ paymentDetails: details });
    }

    // handleSelectChange = (event, name) => {
    //     let select = event.target.value;
    //     let details = this.state.paymentDetails;
    //     details[name] = select;
    //     this.setState({ paymentDetails: details });
    // }

    handleSelectChange = (event, name) => {
        if (name === "selectBank") {
            let arr = [...this.state.mainBankList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.paymentDetails;
            data.bankName = value;
            this.setState({ paymentDetails: data, bankList: found });
        } else if (name === 'paymentMode') {
            let arr = [...this.state.mainPaymentModeList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.paymentDetails;
            data.paymentModeName = value;
            this.setState({ paymentDetails: data, paymentModeList: found });
        } else if (name === 'chequeNo') {
            let arr = [...this.state.mainChequeNoList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.paymentDetails;
            data.chequeNo = value;
            this.setState({ paymentDetails: data, chequeNoList: found });
        }
    }

    handlePartyAccountCellClick = (event) => {
        let data = this.state.paymentDetails;
        data.selectedVendorId = event.data.idPartyAccount;
        data.selectedVendorName = event.data.partyACName;
        this.setState({ paymentDetails: data, isPartyAccountPopUp: !this.state.isPartyAccountPopUp }
            , () => {
                this.getClosingBalance();
            }
        );
    };

    handlSeriesDropdownCellClick = (event) => {
        //debugger;
        //if (event.colDef.field === "piQty") {
        //this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Payment Voucher");
        //}
        let data = this.state.paymentDetails;
        data.idChequeBookMaster = event.data.idChequeBookMaster;
        data.chequeBookSeries = event.data.chequeBookSeries;
        this.setState({ paymentDetails: data, isSeriesPopUp: !this.state.isSeriesPopUp }
            , () => {
                this.usp_Master_ChequeBookNoSelectbyChequeBookSeries();
            }
        );
    };

    handleOnClick = (event, name) => {
        //debugger
        if (name === 'selectVendor') {
            this.setOpenModel2();
            //this.setState({ isPartyAccountPopUp: !this.state.isPartyAccountPopUp });
        } else if (name === 'selectSeries') {
            this.setOpenModel3();
            //this.setState({ isSeriesPopUp: !this.state.isSeriesPopUp });
        }
    }

    setFilterParametersTest = (id, name, drpIdentity) => {
        let data = this.state.paymentDetails;
        if (drpIdentity === 'paymentMode') {
            data.paymentModeId = id;
            data.paymentModeName = name;
        } else if (drpIdentity === 'selectBank') {
            data.idBank = id;
            data.bankName = name;
        } else if (drpIdentity === 'chequeNo') {
            data.idChequeBookDetails = id;
            data.chequeNo = name;
        }
        this.setState({
            paymentDetails: data,
        }, () => {
            if (drpIdentity === 'selectBank') {
                this.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake();
            }
        });
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <>
                <div className='payment-receive'>
                    <div className="data-display">
                        <div className="data-display-inner relative">
                            <ButtonGrp buttons={['add', 'print', 'delete']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.openPopUpForUpdateItem(),
                                    print: this.handlePrint,
                                    delete: this.handleDelete,
                                }} />
                            <PaymentReceivePopUp
                                isModalOpen={this.state.isModalOpen}
                                paymentDetails={this.state.paymentDetails}
                                paymentModeList={this.state.paymentModeList}
                                bankList={this.state.bankList}
                                chequeNoList={this.state.chequeNoList}
                                setOpenModel={this.setOpenModel.bind(this)}
                                close={this.closePopup.bind(this)}
                                handleChange={this.handleChange.bind(this)}
                                handleSelectChange={this.handleSelectChange.bind(this)}
                                handleOnClick={this.handleOnClick.bind(this)}
                                setFilterParametersTest={this.setFilterParametersTest.bind(this)}
                                validState={this.state.validState}
                                submit={this.submit.bind(this)}
                                isSaving={this.state.isSaving}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 h-[78vh] w-full px-[1px] rounded-[5px]">
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Payment receive</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onCellClicked={this.handleCellClick}
                                        onGridReady={this.onGridReady} // Capture API reference
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'} // Custom loading text
                                    />
                                </div>
                            </div>
                            {/* <button onClick={() => this.openPopUpForAddingItem()}>Open</button> */}
                            {/* <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={table2Data}
                                    columnDefs={table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.state.onGridReady}
                                    onCellClicked={this.handleCellClick2}
                                />
                            </div>
                        </div> */}
                        </div>
                    </div>
                </div>
                <PartyAccountPopUp
                    modalName={"Party Account Name"}
                    partyAccountList={this.state.partyAccountList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.paymentModeolDefsColDefs}
                    isModalOpen={this.state.isPartyAccountPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handlePartyAccountCellClick}
                //paymentDetails={this.state.paymentDetails}handleSelectChange
                />
                <PartyAccountPopUp
                    modalName={"Select Series"}
                    partyAccountList={this.state.series}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.seriesColDefs}
                    isModalOpen={this.state.isSeriesPopUp}
                    setOpenModel={this.setOpenModel3.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handlSeriesDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </>
        )
    }
}
export default PaymentReceive;